export default {
  categories: 'mp,op,r,c,i,e',
  all_languages: true,
  min_score: 5,
  order_by: 'top',
  limit: 20,
};
